import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService, DashboardService, UserService } from '@app/_services';
import { first } from 'rxjs/operators';

@Component({ selector: 'profile', templateUrl: 'profile.component.html' })
export class ProfileComponent {

    userId: any;
    user: any;
    userStatus: string;
    activitiesCount: number;
    ownProfile: boolean;

    constructor(private route: ActivatedRoute, private userService: UserService, 
        private dashboardService: DashboardService, private authenticationService: AuthenticationService){
        this.route.paramMap.subscribe(params => {
            this.userId = params.get('participant');

            if(this.userId){
                this.ownProfile = false;
            }
            else {
                this.userId = this.authenticationService.currentUserValue.id.toString();
                this.ownProfile = true;
            }
        });
    }

    ngOnInit() {
        this.userService.getBy(this.userId).pipe(first()).subscribe(data => {
            this.user = data;
            this.user.location = `${data.location.cityName}, ${data.location.countryName}`;
        });

        this.getUserStatus();
    }

    getUserStatus() {
        this.dashboardService.getUserStatus(this.userId).pipe(first()).subscribe(data => {
            this.userStatus =  data.status;
            this.activitiesCount = data.activitiesCount;
        });
    }

    getProfileLink(){
        return ['/dashboard/profile/edit'];
    }
}